import React, { useEffect, useState, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@mui/material/Dialog';
import { Stack } from '@mui/material';
import LevelButtonGroup from './LevelButtonGroup';

function Level2CodeDialog({
  okCallback,
  updateCallback,
  deleteCallback,
  cancelCallback,
  visible,
  l1code,
  newCode,
  defaultDescription,
  updateLevel2,
}) {
  const [level2Code, setLevel2Code] = useState(newCode);
  const [description, setDescription] = useState(defaultDescription);
  const descriptionRef = useRef(null);

  const handlel2Change = event => {
    setLevel2Code(event.target.value);
  };

  const handleDescription = event => {
    setDescription(event.target.value);
  };

  const handleAdd = () => {
    if (description == '') {
      alert('Please enter all fields.');
    } else {
      const data = {
        Discription: description,
        code: level2Code,
        fullcode: l1code + '-' + level2Code,
      };
      okCallback(data);
    }
  };

  const handleCancel = () => {
    cancelCallback();
  };
  const handleUpdate = () => {
    const data = {
      Discription: description,
      code: level2Code,
      fullcode: l1code + '-' + level2Code,
    };
    updateCallback(data);
  };
  const handleDelete = () => {
    const data = {
      Discription: description,
      code: level2Code,
      fullcode: l1code + '-' + level2Code,
    };
    deleteCallback(data);
  };

  return (
    <Dialog open={visible} onClose={cancelCallback}>
      <Stack
        style={{
          minWidth: '40vw',
          height: '50vh',
          padding: '2rem',
        }}
        alignItems="center"
      >
        <TextField
          style={{ width: '90%' }}
          id="l1code"
          label="Level 1 code"
          value={l1code}
          disabled={updateLevel2}
          InputProps={{
            disableUnderline: false,
            margin: 'dense',
            readOnly: true,
          }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          onChange={handlel2Change}
          style={{ width: '90%' }}
          required
          id="outlined-required"
          label="Level 2 code"
          disabled={updateLevel2}
          type="number"
          value={level2Code}
        />
        <TextField
          onChange={handleDescription}
          style={{ width: '90%' }}
          required
          inputRef={descriptionRef}
          value={description}
          id="outlined-required"
          label="Description"
        />
        <LevelButtonGroup
          updateLevel={updateLevel2}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
          handleCancel={handleCancel}
          handleAdd={handleAdd}
        />
      </Stack>
    </Dialog>
  );
}

export default Level2CodeDialog;
